import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { DetailKpiCard } from '../models/detail-page.model'
import { DetailKpiCardComponent } from '../detail-kpi-card/detail-kpi-card.component'

/**
 * Lays out a row of KPI tiles in a responsive grid.
 *
 * Each tile is a `<app-detail-kpi-card>` — render that directly if you
 * need a single tile outside the row layout (sidebar, callout, etc.).
 */
@Component({
    selector: 'app-detail-kpi-row',
    standalone: true,
    imports: [CommonModule, DetailKpiCardComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-kpi-row.component.html',
    styleUrls: ['./detail-kpi-row.component.scss']
})
export class DetailKpiRowComponent {
    @Input() cards: DetailKpiCard[] = []
    @Input() testId?: string
    @Output() linkClicked = new EventEmitter<DetailKpiCard>()

    onLink(card: DetailKpiCard): void {
        this.linkClicked.emit(card)
    }
}
